import { isArray } from 'lodash-es'

import { STATUSES } from './constants'

export const getAppliedFilters = (status) => {
  if (!isArray(status)) { return [] }

  return status.filter((s) => STATUSES.includes(s))
}
